import { FileBarChart } from "lucide-react";
import PageHeader from "@/layout/PageHeader";

export default function QuarterlyStateOfIndustry() {
  return (
    <div data-testid="quarterly-state-industry-page">
      <PageHeader title="Quarterly State of the Industry Report" subtitle="Coming soon." />
      <div className="hm-surface p-12 text-center" data-testid="quarterly-state-industry-empty">
        <FileBarChart className="h-6 w-6 text-hm-fg-subtle mx-auto mb-3" />
        <div className="text-sm text-hm-fg-muted">
          The flagship 90-day synthesis — macro shifts, category movements,
          and Beyond Activ positioning. Not wired yet.
        </div>
      </div>
    </div>
  );
}
